import { render, staticRenderFns } from "./docentes.vue?vue&type=template&id=5614b156&scoped=true"
import script from "./docentes.vue?vue&type=script&lang=js"
export * from "./docentes.vue?vue&type=script&lang=js"
import style0 from "./docentes.vue?vue&type=style&index=0&id=5614b156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5614b156",
  null
  
)

export default component.exports